/* GENERATED from src/js/ndog-hotspots.js — edit the source, then run `make js`. Never edit this file by hand. */
/*
  ndog-hotspots.js
  Self-contained web component for the NDOG Hotspots section.
  Opens one hotspot at a time as a centered modal (fade in/out) with a backdrop.
  Visibility is driven by the .is-open class so it can animate. No dependencies.
  The button list below the image mirrors the hotspots and triggers the same popup.
*/
if (!customElements.get('ndog-hotspots')) {
  customElements.define(
    'ndog-hotspots',
    class NdogHotspots extends HTMLElement {
      // Cache elements and wire events. Bail out if there are no interactive spots.
      connectedCallback() {
        this.backdrop = this.querySelector('[data-backdrop]');
        this.buttons = Array.from(this.querySelectorAll('.ndog-hotspot[aria-controls]'));
        this.triggers = Array.from(this.querySelectorAll('.ndog-hotspots__list-item[data-target]'));
        if (this.buttons.length === 0) return;

        this.openItem = null;
        this.bindEvents();
      }

      // Remove document-level listeners so nothing leaks.
      disconnectedCallback() {
        if (this.onDocClick) document.removeEventListener('click', this.onDocClick);
        if (this.onKey) document.removeEventListener('keydown', this.onKey);
        // Release the scroll lock if the section is removed while a popup is open
        if (this.openItem) document.body.classList.remove('ndog-scroll-lock');
      }

      bindEvents() {
        this.buttons.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.toggleItem(btn.closest('.ndog-hotspots__item'));
          });
        });

        // List buttons open the same popup as their matching dot.
        this.triggers.forEach((trigger) => {
          trigger.addEventListener('click', (e) => {
            e.stopPropagation();
            const item = this.querySelector('#' + trigger.dataset.target);
            if (item) this.toggleItem(item);
          });
        });

        this.querySelectorAll('.ndog-hotspot__close').forEach((close) => {
          close.addEventListener('click', () => this.close());
        });
        if (this.backdrop) this.backdrop.addEventListener('click', () => this.close());

        // Close on outside click / Escape.
        this.onDocClick = (e) => {
          if (this.openItem && !this.openItem.contains(e.target)) this.close();
        };
        this.onKey = (e) => {
          if (e.key === 'Escape' && this.openItem) this.close();
        };
        document.addEventListener('click', this.onDocClick);
        document.addEventListener('keydown', this.onKey);
      }

      // Toggle the modal that belongs to a hotspot item.
      toggleItem(item) {
        if (!item) return;
        if (this.openItem === item) { this.close(); return; }
        this.open(item);
      }

      // Open a hotspot: fade in modal + backdrop, highlight its list button, manage focus.
      open(item) {
        this.close();
        const pop = item.querySelector('.ndog-hotspot__popover');
        if (!pop) return;
        const btn = item.querySelector('.ndog-hotspot');
        pop.classList.add('is-open');
        if (this.backdrop) this.backdrop.classList.add('is-open');
        // Lock background scrolling while the popup is open (class lives in ndog-pdp-redesign.css)
        document.body.classList.add('ndog-scroll-lock');
        if (btn) btn.setAttribute('aria-expanded', 'true');
        this.setTriggerActive(item, true);
        this.openItem = item;
        const target = pop.querySelector('.ndog-hotspot__close') || pop;
        target.focus({ preventScroll: true });
      }

      // Close the open modal and restore focus to its hotspot button.
      close() {
        if (!this.openItem) return;
        const pop = this.openItem.querySelector('.ndog-hotspot__popover');
        const btn = this.openItem.querySelector('.ndog-hotspot');
        if (pop) pop.classList.remove('is-open');
        if (btn) { btn.setAttribute('aria-expanded', 'false'); btn.focus({ preventScroll: true }); }
        this.setTriggerActive(this.openItem, false);
        if (this.backdrop) this.backdrop.classList.remove('is-open');
        document.body.classList.remove('ndog-scroll-lock');
        this.openItem = null;
      }

      // Toggle the highlighted state on the list button that targets this item.
      setTriggerActive(item, active) {
        const trigger = this.triggers.find((t) => t.dataset.target === item.id);
        if (trigger) trigger.classList.toggle('is-active', active);
      }
    }
  );
}
